<template lang="pug">
  m-table(
    store-name="adminperiods"
    :headers="headers"
    :query-filter="queryFilter"
  )
</template>

<script>
import MTable from '~/components/modules/tables/m-table'
import { periodStatuses, planTypesUkMap } from '~/modules/billing/constants/common'

export default {
  name: 'BlockOrganizationPeriods',
  components: { MTable },
  props: {
    organizationId: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Organization name',
          value: 'organization.name',
          sortable: false,
          filterable: false
        },
        {
          text: 'Edrpou',
          value: 'organization.edrpou',
          sortable: false,
          filterable: false
        },
        {
          text: 'Period (from - to)',
          valueFormatter: period =>
            this.$moment.parseZone(period.startDate).format('DD.MM.YYYY') +
            ' - ' +
            this.$moment.parseZone(period.endDate).format('DD.MM.YYYY'),
          sortable: false,
          filterable: false
        },
        {
          text: 'Type',
          valueFormatter: period => planTypesUkMap[period.type],
          sortable: false,
          filterable: false
        },
        {
          text: 'Used documents',
          value: 'usedDocuments',
          sortable: false,
          filterable: false
        },
        {
          text: 'Available documents',
          value: 'availableDocuments',
          sortable: false,
          filterable: false
        },
        {
          text: 'Status',
          value: 'status',
          component: 'e-status-chip',
          componentProps: {
            statuses: periodStatuses
          },
          sortable: false,
          filterable: false
        },
        {
          text: 'Trial access',
          valueFormatter: period => (period.isTrial ? this.$t('Yes') : this.$t('No')),
          sortable: false,
          filterable: false
        },
        {
          text: 'Sum, ₴',
          valueFormatter: period => (period.sum / 100).toFixed(2),
          sortable: false,
          filterable: false
        }
      ]
    },
    queryFilter() {
      return {
        'organization.id': this.organizationId
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
